import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import BunkeyApi from "../../api/BunkeyAPI";
// import fileExtension from "file-extension";
// import { Player, BigPlayButton, LoadingSpinner } from "video-react";

export class BunkeyHostEmbed extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {},
      quality: "optimized",
    };
  }

  componentDidMount() {
    const { id, quality } = this.props.match.params;
    if (id) {
      BunkeyApi({
        url: `/embed/${id}`,
        method: "GET",
      })
        .then((resp) => {
          if (resp && resp.status === 200) {
            this.setState({
              data: resp.data.result,
              src: quality
                ? quality === "low"
                  ? resp.data.result.lowQualityURL
                  : quality === "media"
                  ? resp.data.result.mediaQualityURL
                  : resp.data.result.originalURL
                : resp.data.result.originalURL,
            });
          }
        })
        .catch((err) => {
          console.log("ERR", err);
        });
    }
  }

  render() {
    const { data, src } = this.state;
    // const ext = fileExtension(data.originalURL);

    if (src) {
      const downloadFrame = document.createElement("iframe");
      downloadFrame.setAttribute("id", data._id);
      downloadFrame.setAttribute("src", src);
      downloadFrame.setAttribute(
        "style",
        "border: 0; clip: rect(0 0 0 0); height: 1px; margin: -1px; overflow: hidden; padding: 0"
      );
      document.body.appendChild(downloadFrame);
      setTimeout(() => {
        document.body.removeChild(downloadFrame);
      }, 1000);
    }

    return <React.Fragment />;

    // return (
    //   <React.Fragment>
    //     {(ext === "png" ||
    //       ext === "jpg" ||
    //       ext === "jpeg" ||
    //       ext === "gif") && <img src={src} alt={data.name} />}
    //     {(ext === "mp4" || ext === "avi") && (
    //       <Player
    //         loop={true}
    //         autoPlay={false}
    //         fluid={true}
    //         ref={(player) => {
    //           this.player = player;
    //         }}
    //       >
    //         <LoadingSpinner />
    //         <BigPlayButton position="center" />
    //         <source src={src} />
    //       </Player>
    //     )}
    //   </React.Fragment>
    // );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default injectIntl(
  withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(BunkeyHostEmbed)
  )
);
